import {ActionTree, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import axios from 'axios';
import VueI18n from '../../helpers/i18n';
import api from "@/service/api";
import any = jasmine.any;

export interface State {
    show: any[];
    currentShow: any[];
    currentExhibition: any;
    isNewShow: boolean;
    codeCurrentShow: string;
    directory: any[];
    plan:string;
    planStatus:string;
}

const defaultState: State = {
    show: [],
    currentShow: [],
    isNewShow: false,
    codeCurrentShow: '',
    directory: [],
    currentExhibition: {},
    plan: '',
    planStatus: '',
};

const getters = {
    getShow: (state: State) => state.show,
    getCurrentShow: (state: State) => state.currentShow,
    getIsNewShow: (state: State) => state.isNewShow,
    getDirectory: (state: State) => state.directory,
    getCurrentExhibition: (state: State) => state.currentExhibition,
    getPlan: (state: State) => state.plan,
    getPlanStatus: (state: State) => state.planStatus,
    // getPlanStatus: (state: State) => state.currentExhibition ? state.currentExhibition.companyParticipation ? state.currentExhibition.companyParticipation.status : '' : '',
}
const mutations: MutationTree<State> = {
    addShowToFolder(state: State, payload: any) {

        state.directory.map((folder: any) => {
            if (folder._id == payload.folder) {
                folder.showCount++
            }
            return folder
        })
        state.show.map((show: any) => {
            if (show.code == payload.show) {
                show.directories.push(state.directory.filter(el=>el._id === payload.folder)[0])
            }
            return show
        })
    },
    delShowToFolder(state: State, payload: any) {

        state.directory.map((folder: any) => {
            if (folder._id == payload.folder) {
                folder.showCount--
            }
            return folder
        })
        state.show.map((show: any) => {
            if (show.code == payload.show) {
                let  index =  show.directories.findIndex((n:any) => n._id === payload.folder);
                if (index !== -1) {
                    show.directories.splice(index, 1);
                }
            }
            return show
        })
    },
    setShow(state: State, payload: any) {
        state.show = payload
    },
    editShow(state: State, payload: any) {
        state.show = state.show.map((show: any) => show._id == payload._id ? {...payload, directories: show.directories} : show)
    },
    setNewShow(state: State, payload: any) {
        state.show.push(payload)
        state.isNewShow = true
        state.codeCurrentShow = payload.code
    },
    setCodeCurrentShow(state: State, payload: string) {
        state.codeCurrentShow = payload
    },
    setCurrentShow(state: State, payload: any) {
        state.currentShow = payload
    },
    setDirectory(state: State, payload: any) {
        payload.map((item: any) => item.isEdit = false)
        state.directory = payload.sort((a: any, b: any) => {
            return a.title.toLowerCase().localeCompare(b.title.toLowerCase());
        })
    },
    addDirectory(state: State, payload: any) {
        payload.isEdit = false
        state.directory = state.directory.filter((item) => !!item._id)
        state.directory.push({...payload, showCount:0})
        state.directory = state.directory.sort((a: any, b: any) => {
            return a.title.localeCompare(b.title);
        })

    },
    changeDirectory(state: State, payload) {
        state.directory = state.directory.map((item) => (item._id == payload.id) ? payload : item)
        state.directory = state.directory.sort((a: any, b: any) => {
            return a.title.toLowerCase().localeCompare(b.title.toLowerCase());
        })
    },
    deleteDirectory(state: State, payload: string) {
        state.directory = state.directory.filter((item) => item._id != payload)
    },
    setCurrentExhibition(state: State, payload: string) {
        state.currentExhibition = state.show.filter((item:any) =>  item.code == payload)[0]
        state.plan = state.currentExhibition && state.currentExhibition.companyParticipation ? state.currentExhibition.companyParticipation.plan : ''
        state.planStatus = state.currentExhibition && state.currentExhibition.companyParticipation ? state.currentExhibition.companyParticipation.status : 'active'
    },
    setJoinCurrentExhibition(state: State, payload: any) {
        state.currentExhibition = state.show.filter((item:any) =>  item.code == payload.show)[0]
        state.currentExhibition.companyParticipation = payload.companyParticipation
    },
    setPlan(state: State, payload: any) {
        state.show.forEach((item:any) =>   {
            if(item._code == payload._show) {
                item.userParticipation = {
                    plan: payload.plan
                }
            }
        })
        state.plan = payload.plan
    },
    setCompanyPlan(state: State, payload: any) {
        state.show.forEach((item:any) =>   {
            if(item.code == payload._show) {
                item.companyParticipation.status = payload.companyParticipation.status
                item.companyParticipation.plan = payload.companyParticipation.plan
                item.companyParticipation.show = payload.companyParticipation.show
            }
        })
        state.plan = payload.companyParticipation.plan
        state.planStatus = payload.companyParticipation.status
    }
}

const actions: ActionTree<State, RootState> = {
    async getUserShowFromServer({commit}) {
        try {
            const {data} = await api.go('getShow', {
                query: {
                    expand: 'directories'
                }
            })
            commit('setShow', data.data)
        } catch (e) {
            console.log(e)
        }
    },
    async getCompanyShowFromServer({commit}, payload: any) {
        try {
            const {data} = await api.go('getCompanyShowFromServer', {
                params: {
                    CompanyCode: payload.CompanyCode
                },
                query: {
                    expand: 'directories,companyParticipation.options',
                    onlyWithUserParticipation:payload.onlyWithUserParticipation
                }
            })
            commit('setShow', data.data)
        } catch (e) {
            console.log(e)
        }
    },
    async getUserDirectoryFromServer({commit}) {
        try {
            const {data} = await api.go('getUserDirectory')
            commit('setDirectory', data.data)
        } catch (e) {
            console.log(e)
        }
    },
    async getCompanyDirectoryFromServer({commit}, payload: string) {
        try {
            const {data} = await api.go('getCompanyDirectory', {params: {CompanyCode: payload}})
            commit('setDirectory', data.data)
        } catch (e) {
            console.log(e)
        }
    },
    async addUserDirectory({commit,dispatch}, payload: any) {
        try {
            const {data} = await api.go('addUserDirectory', {body: payload})
            commit('addDirectory', data.data)

            if(payload.deferredExhibitionBySetFolder){
                this.dispatch('workspace/setExhibitionDirectory',{
                    show:payload.deferredExhibitionBySetFolder,
                    folder: data.data._id,
                })
            }
        } catch (e) {
            console.log(e)
        }
    },
    async addCompanyDirectory({commit}, payload: any) {
        try {
            const {data} = await api.go('addCompanyDirectory', {
                params: {CompanyCode: payload.company},
                body: payload.params
            })
            commit('addDirectory', data.data)
            if(payload.params.deferredExhibitionBySetFolder){
                this.dispatch('workspace/setCompanyExhibitionDirectory',{
                    show:payload.params.deferredExhibitionBySetFolder,
                    folder: data.data._id,
                    CompanyCode:payload.company
                })
            }
        } catch (e) {
            console.log(e)
        }
    },
    async saveUserDirectory({commit}, payload: any) {
        try {
            const {data} = await api.go('saveUserDirectory', {params: {DirectionId: payload.id}, body: payload.params})
            commit('changeDirectory', data.data)
        } catch (e) {
            console.log(e)
        }
    },
    async saveCompanyDirectory({commit}, payload: any) {
        try {
            const {data} = await api.go('saveCompanyDirectory', {
                params: {
                    CompanyCode: payload.company,
                    DirectionId: payload.id
                }, body: payload.params
            })
            commit('changeDirectory', data.data)
        } catch (e) {
            console.log(e)
        }
    },
    async deleteUserDirectory({commit}, payload: string) {
        try {
            const {data} = await api.go('deleteUserDirectory', {params: {DirectionId: payload}})
            commit('deleteDirectory', payload)
        } catch (e) {
            console.log(e)
        }
    },
    async deleteCompanyDirectory({commit}, payload: any) {
        try {
            const {data} = await api.go('deleteCompanyDirectory', {
                params: {
                    CompanyCode: payload.company,
                    DirectionId: payload.id
                }
            })
            commit('deleteDirectory', payload.id)
        } catch (e) {
            console.log(e)
        }
    },
    async joinUserExhibition({commit}, payload: string) {
        try {
            const {data} = await api.go('joinUserExhibition', {params: {ShowCode: payload}, body: {plan: 'free'}})
            commit('setPlan', data.data)
        } catch (e) {
            console.log(e)
        }
    },
    async joinCompanyExhibition({commit}, payload: any) {
        try {
            const {data} = await api.go('joinCompanyExhibition', {params: {CompanyCode: payload.company, ShowCode: payload.show}, body: {plan: payload.plan}})
            commit('setCompanyPlan', data.data)
            commit('setJoinCurrentExhibition', {show: payload.show, companyParticipation: data.data.companyParticipation})
        } catch (e) {
            console.log(e)
        }
    },
    async changePlan({commit}, payload: any) {
        try {
            const {data} = await api.go('changePlan', {params: payload.params, body: payload.body})
            commit('setCompanyPlan', {...data.data, _show: payload._show})
            if(data.data.companyParticipation.show.wasStarted) {
                this.commit('dialog/SetModalSupportShow', true)
            }
        } catch (e) {
            console.log(e)
        }
    },
    async getCurrentUserExhibitions({commit}, payload: any) {
        try {
            const {data} = await api.go('getCurrentUserExhibitions', {
                query: {
                    limit: 6,
                    sort: '-dateStart',
                    dateEndFrom: payload.date
                }
            })
            commit('setCurrentShow', data.data)
        } catch (e) {
            console.log(e)
        }
    },
    async getCurrentCompanyExhibitions({commit}, payload: any) {
        try {
            const {data} = await api.go('getCurrentCompanyExhibitions', {
                query: {
                    limit: 6,
                    sort: '-dateStart',
                    dateEndFrom: payload.date
                },
                params: {
                    CompanyCode: payload.company
                }
            })
            commit('setCurrentShow', data.data)
        } catch (e) {
            console.log(e)
        }
    },
    async getSearchedUserExhibitions({commit}, payload: string) {
        try {
            const {data} = await api.go('getSearchedUserExhibitions', {
                query: {
                    search: payload,
                    limit: 6,
                    sort: '-dateStart'
                }
            })
            commit('setCurrentShow', data.data)
        } catch (e) {
            console.log(e)
        }
    },
    async getSearchedCompanyExhibitions({commit}, payload: any) {
        try {
            const {data} = await api.go('getSearchedCompanyExhibitions', {
                params: {
                    CompanyCode: payload.company
                },
                query: {
                    search: payload.search,
                    limit: 6,
                    sort: '-dateStart'
                }
            })
            commit('setCurrentShow', data.data)
        } catch (e) {
            console.log(e)
        }
    },

    async addUserExhibition({commit}, payload: any) {
        try {
            const {data} = await api.go('addUserExhibition', {
                body: payload
            })
            data.data.directories = []
            commit('setNewShow', data.data)
        } catch (e) {
            this.commit('dialog/SetModalError', {show: true, error: 'someError'})
        }
    },
    async addCompanyExhibition({commit, state}, payload: any) {
        try {
            state.isNewShow = false
            const {data} = await api.go('addCompanyExhibition', {
                params: {
                    CompanyCode: payload.company
                },
                body: payload.params
            })
            data.data.directories = []
            commit('setNewShow', data.data)
        } catch (e) {
            this.commit('dialog/SetModalError', {show: true, error: 'someError'})
        }
    },

    async updateUserExhibition({commit, state}, payload: any) {
        try {
            const {data} = await api.go('updateUserExhibition', {
                params: {
                    CodeCurrentShow: state.codeCurrentShow
                },
                body: payload
            })
            state.isNewShow = false
            commit('editShow', data.data)
        } catch (e) {
            console.log(e)
        }
    },
    async updateCompanyExhibition({commit, state}, payload: any) {
        try {
            const {data} = await api.go('updateCompanyExhibition', {
                params: {
                    companyCode: payload.params.company,
                    CodeCurrentShow: state.codeCurrentShow
                },
                body: payload.body
            })
            state.isNewShow = false
            commit('editShow', data.data)
        } catch (e) {
            console.log(e)
        }
    },
    async deleteUserExhibition({commit, state}, payload: any) {
        try {
            const {data} = await api.go('deleteUserExhibition', {
                params: {
                    CodeCurrentShow: payload.CodeCurrentShow
                }
            })
            if(data.data.status == 'ok'){
                let index =  state.show.findIndex((el:any)=>el.code == payload.CodeCurrentShow)
                if(index !== -1){
                    state.show.splice(index,1)
                }
            }
        } catch (e) {
            this.commit('dialog/SetModalError', {show: true, error: 'someError'})
        }
    },
    async deleteCompanyExhibition({commit, state}, payload: any) {
        try {
            const {data} = await api.go('deleteCompanyExhibition', {
                params: {
                    companyCode: payload.CompanyCode,
                    CodeCurrentShow: payload.CodeCurrentShow
                }
            })
           if(data.data.status == 'ok'){
               let index =  state.show.findIndex((el:any)=>el.code == payload.CodeCurrentShow)
               if(index !== -1){
                  state.show.splice(index,1)
               }
           }
        } catch (e) {
            this.commit('dialog/SetModalError', {show: true, error: 'someError'})
        }
    },

    async setExhibitionDirectory({commit, state}, payload: any) {
        try {
            const {data} = await api.go('setExhibitionDirectory', {
                params: {
                    folder: payload.folder,
                    show: payload.show
                }
            })
            commit('addShowToFolder', {
                folder: payload.folder,
                show: payload.show
            })
        } catch (e) {
            console.log(e)
        }
    },
    async setCompanyExhibitionDirectory({commit, state}, payload: any) {

        try {
            const {data} = await api.go('setCompanyExhibitionDirectory', {
                params: {
                    folder: payload.folder,
                    show: payload.show,
                    CompanyCode:payload.CompanyCode
                }
            })
            commit('addShowToFolder', {
                folder: payload.folder,
                show: payload.show
            })
        } catch (e) {
            console.log(e)
        }
    },
    async delExhibitionDirectory({commit, state}, payload: any) {
        try {
            const {data} = await api.go('delExhibitionDirectory', {
                params: {
                    folder: payload.folder,
                    show: payload.show
                }
            })
            commit('delShowToFolder', {
                folder: payload.folder,
                show: payload.show
            })
        } catch (e) {
            console.log(e)
        }
    },
    async delCompanyExhibitionDirectory({commit, state}, payload: any) {
        try {
            const {data} = await api.go('delCompanyExhibitionDirectory', {
                params: {
                    folder: payload.folder,
                    show: payload.show,
                    CompanyCode:payload.CompanyCode
                }
            })
            commit('delShowToFolder', {
                folder: payload.folder,
                show: payload.show
            })
        } catch (e) {
            console.log(e)
        }
    }
};

export default {
    namespaced: true,
    state: defaultState,
    getters,
    mutations,
    actions,
};
